module.exports = __webpack_public_path__ + "static/sw-sticker-bf7e9d147fcb06122fa606fc5a0211e7.png";